/**
 * Shared responsive values for consistent breakpoints across the app.
 * Use with Chakra props: fontSize={ responsive.pageTitle }, px={ responsive.cardPaddingX }, etc.
 * Breakpoints: base (mobile), sm 415px+, md 768px+, lg 1000px+, xl 1440px+
 */
export const responsive = {
  pageTitle: { base: '18px', sm: '20px', md: '22px' },
  sectionTitle: { base: '16px', sm: '17px', md: '18px' },
  body: { base: '12px', sm: '13px', md: '14px' },
  bodySmall: { base: '11px', sm: '12px' },
  caption: { base: '10px', sm: '11px', md: '12px' },
  cardPaddingX: { base: 3, sm: 4, md: 5 },
  cardPaddingY: { base: 3, sm: 4 },
  pagePaddingX: { base: 3, sm: 4, md: 5, lg: 6 },
  pagePaddingBottom: { base: 4, sm: 5, md: 6 },
  tableCellPy: { base: '8px', sm: '10px' },
  tableCellPx: { base: 2, sm: 3 },
  tableHeaderFontSize: { base: '12px', sm: '13px', md: '14px' },
  tableCellFontSize: { base: '12px', sm: '13px', md: '14px' },
  paginationGap: { base: 1, sm: 2 },
  paginationFontSize: { base: '11px', sm: '12px' },
} as const;
